import { RotateCcw } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
} from '@design-system';
import { useConsumerFlowReset } from '../hooks/use-consumer-flow-reset';

export function ConsumerFlowResetButton({ clientId }: { clientId: string }) {
  const { canReset, resetFlow, isResetting, isError } = useConsumerFlowReset(clientId);
  if (!canReset) return null;

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="outline" size="sm" disabled={isResetting}>
          <RotateCcw />
          Reset consumer flow
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Reset this client’s consumer flow?</AlertDialogTitle>
          <AlertDialogDescription>
            This deletes their guided-flow progress and choices (including the policy added from their
            selected option), partner, care adjustments, submitted
            applications, policy reviews and self-funding purchase, so the flow starts from the
            beginning. Their intake and onboarding results stay. This can’t be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        {isError && <p className="text-destructive text-sm">The reset didn’t go through. Please try again.</p>}
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={event => {
              event.preventDefault();
              resetFlow();
            }}
            disabled={isResetting}
          >
            {isResetting ? 'Resetting…' : 'Reset everything'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
